// PRODUCTS
import cardSocialLinks from "@/views/card/social-links/reorder.gql";
import cardOtherLinks from "@/views/card/links/reorder.gql";
import cardContacts from "@/views/card/contacts/reorder.gql";

export default {
  cardContacts,
  cardOtherLinks,
  cardSocialLinks,
};
